/**
 * Returns the path to the Housien brand logo.
 *
 * `housien-light.png` and `housien-dark.png` are named for the logo's own
 * ink color, not the background it sits on — pass `onDark` when placing the
 * logo over a dark background so the light-ink asset is used instead.
 */
export function useLogoSource(onDark = false): string {
  return onDark ? '/images/logo/housien-dark.png' : '/images/logo/housien-light.png';
}
